import { render, staticRenderFns } from "./product-list-settings-modal.vue?vue&type=template&id=8cf4dcce&scoped=true"
import script from "./product-list-settings-modal.vue?vue&type=script&lang=js"
export * from "./product-list-settings-modal.vue?vue&type=script&lang=js"
import style0 from "./product-list-settings-modal.vue?vue&type=style&index=0&id=8cf4dcce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf4dcce",
  null
  
)

export default component.exports